__turbopack_context__.v({
  "color": "learn-table-module-scss-module__v8fOgq__color",
  "form": "learn-table-module-scss-module__v8fOgq__form",
  "formControl": "learn-table-module-scss-module__v8fOgq__formControl",
  "style": "learn-table-module-scss-module__v8fOgq__style",
  "typoGraphyRight": "learn-table-module-scss-module__v8fOgq__typoGraphyRight",
  "typoGraphyWrong": "learn-table-module-scss-module__v8fOgq__typoGraphyWrong",
});
